import { useDispatch, useSelector } from "react-redux";
import { useUnityContext } from "../components/container/unityContainer"
import { openSidebarSection } from "../helpers/curatorActions";
import { dispatcher } from "../helpers/projectHelper";
import { CURATOR_MENU_SECTION } from "../redux/slicers/admin/curatorMenuPreferencesSlicer";
import { selectOpenProductsAfterPlacement, setDraggableProductImage } from "../redux/slicers/admin/curatorProductsSlicer";
import { selectDuplicatePropInProgress, setDuplicatePropInProgress } from "../redux/slicers/admin/curatorUnityObjectSlicer";
import { getAppState } from "../redux/store";

export const useUnityProp = () => {
  const dispatch = useDispatch();
  const { roomModule } = useUnityContext();
  const isDuplicateProgress = useSelector(selectDuplicatePropInProgress);
  
  const cancelDraggableProp = () => {
    roomModule.CancelDraggableProp();
    cancelDraggablePropUI(isDuplicateProgress);
  }

  return {
    cancelDraggableProp
  }
}

export const cancelDraggablePropUI = (isDuplicateProgress) => {
  dispatcher(setDraggableProductImage({ image: null }));
  dispatcher(setDuplicatePropInProgress(false));

  if (selectOpenProductsAfterPlacement(getAppState()) && !isDuplicateProgress) {
    openSidebarSection(CURATOR_MENU_SECTION.PRODUCTS)
  }
}